<template>
  <b-card class="no-border mt-3" no-body>
    <user-table />
  </b-card>
</template>
<script>
import UserTable from '@/components/UserTable.vue';

export default {
  name: 'user_list',
  components: {
    UserTable,
  },
  created() {
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'users', name: 'Users' },
    ]);
  },
};
</script>


// WEBPACK FOOTER //
// src/views/pages/admin/users/List.vue